import React from "react";
import CountryForm from "../CountryForm";
import { useParams } from "react-router-dom";

const ViewCountry = () => {
  const params = useParams();
  return <CountryForm mode="VIEW" param={params} />;
};

export default ViewCountry;
